
import { Component, Vue, Watch } from 'vue-property-decorator';
import OrderSearch from './components/OrderSearchCustom.vue';
import OrderList from './components/OrderList.vue';
import { ViewType, OrderServiceStage } from '@/types/orderServicer';
import { Route } from 'vue-router';

@Component({
  name: 'orderServicerUnderway',
  components: {
    OrderSearch,
    OrderList
  }
})
export default class extends Vue {
  private stage = OrderServiceStage.SERVICE_STAGE_UNCOMPLETED;
  private vt = ViewType.ORDER_SERVICER_UNDERWAY;
  private isShowSeach=true;
  private yy = new Date().getFullYear();
  private mm = new Date().getMonth();
  private dd = new Date().getDate();
  private state:any='';
  private name:any=''
  created() {
    this.$nextTick(() => {
      if (this.$route.query && this.$route.query.is_send_eng === '1') {
        this.isShowSeach = false;
        this.name = this.$route.query.work_user_name;
        if (this.$route.query.task_stage === '2') {
          this.state = '未处理';
        }
        if (this.$route.query.task_stage === '3') {
          this.state = '进行中';
        }
      }
    });
  }
  private rest() {
    let query = JSON.parse(JSON.stringify(this.$route.query));
    query.work_user_id = '';
    query.task_stage = '';
    query.is_send_eng = '';
    this.$router.push({
      path: this.$route.path,
      query: query
    });
    setTimeout(() => {
      this.isShowSeach = true;
    }, 1000);
  }
  private getManyDays() {
    let yyyy = 365;
    let y = new Date().getFullYear();
    let flag = y % 400 === 0 || (y % 4 === 0 && y % 100 !== 0);
    if (flag) {
      yyyy = 366;
    }
    return yyyy;
  }
}
